// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"1d7b4aae","455":"7cc20d4a","879":"4e794cc6","977":"0e67277a"}[chunkId] + ".chunk.js";
};